var exports = {
  "k": "xcc377c0b--d0da80--container",
};

module.exports = exports;
